'use strict';

var React  = require('react'),
    Router = require('react-router');

require('js/shared/stores/notification-store.js');
require('js/shared/stores/tracking-store.js');

React.initializeTouchEvents(true);

var ApplicationForm = require('js/screens/form/application.jsx');

var App = React.createClass({
    render: function () {
        return (
            <div>
                <Router.RouteHandler/>
            </div>
        );
    }
});


/**
 * This is where we define the frontend routes. Why? Because we don't ever need to reload
 * the page! We just load different components on different routes and it is all redrawn.
 * This speeds things up a ton. If you are wondering what `react-proxy!` does, read this:
 * https://github.com/webpack/react-proxy-loader. Basically it lazy-loads the stuff we need
 * for that module.
 */

var routes = (
    <Router.Route handler={ApplicationForm}>
        <Router.Route
            name="applyStage"
            path=":applicationStage"
            handler={ApplicationForm} />
    </Router.Route>
);

Router.run(routes, Router.HistoryLocation, function (Handler) {
    React.render(<Handler/>, document.getElementById('application'));
});

console.log("If you're really determined about applying, we're sure you can hack it ;)");


/** WEBPACK FOOTER **
 ** ./js/screens/form/index.jsx
 **/